import { isNil } from 'lodash';

/**
 * Sort keys for `sortBy`, from a list of field names.
 *
 * Two keys per field: whether it is there, and then its value.
 *
 * The presence key first, because `sortBy` puts `undefined` LAST and two detail
 * panels depend on the opposite - they list a raw material's own shipments
 * before the ones that arrive through a mixture, and the direct rows are
 * exactly the ones with no `mixture_code` at all. Sorting by the bare field
 * would turn that upside down.
 *
 * The value key raw, not coerced to a string, or the consumption years come out
 * `10 2 9`.
 *
 * A function passes straight through, so a caller can order by something that
 * is not a field - `row => !selectedIds.includes(row.id)` puts the checked rows
 * on top, which several selector tables want.
 */
export const orderKeys = keys => keys.flatMap(key =>
  typeof key === 'function' ?
    [key] :
    [row => !isNil(row[key]), row => row[key]]
);

export default orderKeys;
